import { render, staticRenderFns } from "./addReformToMaterial.vue?vue&type=template&id=7cc04ddd"
import script from "./addReformToMaterial.vue?vue&type=script&lang=js"
export * from "./addReformToMaterial.vue?vue&type=script&lang=js"
import style0 from "./addReformToMaterial.vue?vue&type=style&index=0&id=7cc04ddd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports